module.exports = __webpack_public_path__ + "static/media/img114_R.feb8c433.jpg";